import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AuthCookieService {
	private readonly cookieName = 'my_ceremony_logged_in';
	private readonly maxAgeSeconds = 60 * 60 * 24;

	isLoggedIn(): boolean {
		const target = `${this.cookieName}=`;
		return document.cookie
			.split(';')
			.map((c) => c.trim())
			.some((c) => c.startsWith(target) && c.length > target.length);
	}

	setLoggedIn(): void {
		const parts = [
			`${this.cookieName}=1`,
			'Path=/',
			`Max-Age=${this.maxAgeSeconds}`,
			'SameSite=Lax',
		];
		const domain = this.resolveCookieDomain();
		if (domain) {
			parts.push(`Domain=${domain}`);
		}
		if (this.isSecureContext()) {
			parts.push('Secure');
		}
		document.cookie = parts.join('; ');
	}

	clearLoggedIn(): void {
		const parts = [
			`${this.cookieName}=`,
			'Path=/',
			'Max-Age=0',
			'Expires=Thu, 01 Jan 1970 00:00:00 GMT',
			'SameSite=Lax',
		];
		const domain = this.resolveCookieDomain();
		if (domain) {
			parts.push(`Domain=${domain}`);
		}
		if (this.isSecureContext()) {
			parts.push('Secure');
		}
		document.cookie = parts.join('; ');
	}

	private resolveCookieDomain(): string | null {
		const host = window.location.hostname;
		if (host === 'localhost' || host === '127.0.0.1') {
			return null;
		}
		if (host.endsWith('.adaytoremember.london') || host === 'adaytoremember.london') {
			return 'adaytoremember.london';
		}
		if (host.endsWith('.staging.bookinglab.co.uk')) {
			return 'staging.bookinglab.co.uk';
		}
		return null;
	}

	private isSecureContext(): boolean {
		return window.location.protocol === 'https:';
	}
}
